import { Component, Input, OnInit } from '@angular/core';
import { ENTITY_NAMES, ORGANIZATION_TYPES, RECORD_STATUS_VALUES, TRAVEL_SERVICES } from '../../shared/constants/api-constants';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { ModalController, PopoverController } from '@ionic/angular';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { StatusUpdateService } from 'src/app/business-service/status-update/status-update.service';
import { LeadEmailInputComponent } from '../../shared/popover/lead-email-input/lead-email-input.component';
import { SendViaSocialMediaComponent } from '../../shared/popover/send-via-social-media/send-via-social-media.component';
import { TableColumnOptionsComponent } from '../../shared/popover/table-column-options/table-column-options.component';
import { EmailService } from '../../shared/services/email/email.service';
import { GlobalService } from '../../shared/services/global/global.service';
import { ModalsService } from '../../shared/services/modals/modals.service';
import { PdfService } from '../../shared/services/pdf.service';
import { ComponentReloadService } from '../../shared/services/reload/component-reload.service';
import { ResponseNotificationService } from '../../shared/services/response-notification/response-notification.service';
import { DmcQuotesService } from 'src/app/business-service/dmc-quotes/dmc-quotes.service';

@Component({
  selector: 'app-dmc-quote-view',
  templateUrl: './dmc-quote-view.component.html',
  styleUrls: ['./dmc-quote-view.component.scss'],
})
export class DmcQuoteViewComponent implements OnInit {

  @Input() quoteId: any;
  quoteData: any;
  quoteDataHtml: SafeHtml = "";
  templateData: any;
  leadId: any;
  clientId: any;

  leadDetails: any;

  @Input() detailsFormData: any;

  quoteStatus: any;
  showSubmitBtn: boolean = false;
  showConvertBtn: boolean = false;
  editQuoteButton: any;
  showFinalizeButton: any;
  showConvertButton: any;

  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;



  constructor(
    private _dmcQuoteService: DmcQuotesService,
    private _modalController: ModalController,
    private _statusUpdateService: StatusUpdateService,
    private _responseNotificationService: ResponseNotificationService,
    private _globalService: GlobalService,
    private _sanitizer: DomSanitizer,
    private _pdfServie: PdfService,
    private _reloadService: ComponentReloadService,
    private _modalPopupService: ModalsService,
    private _leadService: LeadsService,
    private _popoverController: PopoverController,
    private _emailService: EmailService
  ) { }

  ngOnInit() {
    this.UpdateRolesAndActions();
    if (this.quoteId) {
      this._dmcQuoteService.getQuoteData(this.quoteId).subscribe((data) => {
        this.quoteData = data;
        this.leadId = this.quoteData.itineraryDetails.leadId;
        this.detailsFormData = this.quoteData.itineraryDetails;

        if (this.detailsFormData) {
          this.quoteStatus = this.detailsFormData.status;

          if (this.quoteStatus === RECORD_STATUS_VALUES.DRAFT) {
            this.showSubmitBtn = true;
          }
        }

        if (this.leadId) {
          this._leadService.getLead(this.leadId).subscribe((data) => {
            this.clientId = data.clientId;
            this.leadDetails = data;
            // upon getting clienid from lead data call html quote template
            // GEt quote as template
            this._dmcQuoteService.getQuoteTemplateHtml(this.quoteId).subscribe((data) => {

              this.templateData = data;
              this.quoteDataHtml = this._sanitizer.bypassSecurityTrustHtml(this.templateData);

            })
          })
        }
      }, (error) => {
        this._responseNotificationService.showMessage("Something went wrong, please try again!", true);

      })
    } else {
      if (this.detailsFormData) {
        this.quoteStatus = this.detailsFormData.status;

        if (this.quoteStatus === "Draft") {
          this.showSubmitBtn = true;
        }
      }
    }


  }




  closeModal() {
    this._modalController.dismiss()
  }

  // Print html review template
  printQuote(): void {
    this._pdfServie.generatePdf(this.templateData).subscribe(
      (blob) => {
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = url;

        iframe.onload = () => {
          iframe.contentWindow?.print();
        };

        document.body.appendChild(iframe);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  downloadQuote(): void {
    this._pdfServie.generatePdf(this.templateData, true).subscribe(
      (blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Quote_${this.quoteId}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      (error) => {
        console.error('Error generating PDF:', error);
      }
    );
  }

  async openDownloadPopover(event: any) {
    const popover = await this._popoverController.create({
      component: TableColumnOptionsComponent,
      event: event,
      cssClass: 'popup-component',
      componentProps: {
        optionsData: {
          options: [
            { value: "Download", path: "download" },
            { value: "Print", path: "print" }
          ]
        },
        onPathSelected: (data: any) => this.onPrintOptionSelected(data)
      }
    });
    return await popover.present();
  }

  onPrintOptionSelected(data: any) {
    switch (data.path) {
      case "download": {
        this.downloadQuote();
        break;
      }
      case "print": {
        this.printQuote();
        break;
      }
    }
    this._popoverController.dismiss();
  }

  // Open edit popup for quote
  openEditQuoteItinerary() {
    this.closeModal();
    this._modalPopupService.openDmcQuoteForm(this.clientId, this.leadId, this.quoteId, null);
  }

  // Submit quote funtion
  async submitQuote() {
    if (await this._globalService.confirmActionPopup("Submitting a quote will start creating versions when updated.", "Confirm To Submit")) {
      this.makeQuoteActive();
    }
  }


  // Make qupte active
  async makeQuoteActive() {
    this._dmcQuoteService.getQuoteData(this.quoteId).subscribe(async (data) => {
      let keys = Object.keys(data);
      let leadId = data.itineraryDetails.leadId;

      try {
        // Wait for lead travel services to be fetched
        let leadTravelServices = await this._globalService.getLeadsTravelServices(leadId);

        if (!leadTravelServices.showHotels) {
          keys = keys.filter(item => item !== "accommodations");
        }
        if (!leadTravelServices.showRouteCraft) {
          keys = keys.filter(item => item !== "routeCrafts");
        }
        // Revovining transport related keys
        keys = keys.filter(item => !["notes", "tickets" , "paymentTermsAndConditions"].includes(item));


        // Check if any data keys are null
        for (let key of keys) {
          if (data[key] === null) {
            await this._globalService.customAlert("Fill all quote details to submit");
            this.closeModal();
            this._modalPopupService.openDmcQuoteForm(this.clientId, leadId, this.quoteId, null);
            return;
          }
        }

        // Update status after validation
        this._statusUpdateService.updateStatusOfRecord(ENTITY_NAMES.DMC_QUOTE, this.quoteId, RECORD_STATUS_VALUES.ACTIVE).subscribe((data) => {
          if (data) {
            this._responseNotificationService.showMessage("Quote Is Active!");
            this.ngOnInit();
            // this.saveAsInventoryItinerary(this.quoteId);
          }
          this._reloadService.triggerQuotesReload();
        });

      } catch (error) {
        console.error('Error fetching lead travel services:', error);
      }
    });
  }

  async saveAsInventoryItinerary(quoteId: any) {
    if (this.leadDetails?.travelServices?.includes(TRAVEL_SERVICES.SIGHTSEEING)) {
      if (await this._globalService.confirmActionPopup("Do you want to save this quote in Inventory?", "Save in inventory", "Yes")) {
        this._dmcQuoteService.saveAsInventoryItinerary(quoteId).subscribe((data) => {
          if (data) {
            this._responseNotificationService.showMessage("Quote saved as Inventory Itinerary!");
          }
        },
          (error) => {
            this._responseNotificationService.showMessage("Failed to save as Inventory Itinerary!", true);
          }
        )
      }
    }
  }

  // Make quote final
  async finalizeQuote(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this._statusUpdateService.finalizeDmcQuote(this.leadId, this.quoteId).subscribe({
        next: (data) => {
          if (data) {
            this._responseNotificationService.showMessage("Quote Confirmed!");
            this.ngOnInit();
            this._reloadService.triggerQuotesReload();
            this._reloadService.triggerLeadsReload();
            this._reloadService.triggerTasksReload();
            resolve(true);
          }
        }, error: (err) => {
          reject(false);
        }
      })
    });
  }

  // convert quote
  async convertQuote() {
    if (await this._globalService.confirmActionPopup("Once Quote is confirmed it cannot be edited futhuer. Please confirm")) {
      await this.changeRecordStatus(ENTITY_NAMES.DMC_QUOTE, this.quoteId, RECORD_STATUS_VALUES.CONVERTED);
      await this.changeRecordStatus(ENTITY_NAMES.LEAD, this.leadId, RECORD_STATUS_VALUES.CONVERTED);
      await this.changeRecordStatus(ENTITY_NAMES.CLIENT, this.clientId, RECORD_STATUS_VALUES.CONVERTED);
      this._reloadService.triggerQuotesReload();
      this._responseNotificationService.showMessage("Quote converted successfully");
      this.ngOnInit();
    }
  }

  async changeRecordStatus(category:any, id: any, value: any): Promise<boolean>{
    return new Promise<any>((resolve, reject)=>{
      this._statusUpdateService.updateStatusOfRecord(category, id, value).subscribe({
        next: (data)=>{
          resolve(true);
        }, error: ()=>{
          resolve(false)
        }
      });
    })
  }

  // Final and convert quote
  async finalizeAndConvertQuote() {
    await this.finalizeQuote();
  }

  UpdateRolesAndActions() {
    this._globalService.roles$.subscribe((roles) => {
      const leadModule = roles?.modules.find((module: any) => module.name === "Leads");
      const permissions = leadModule.permissions;
      if (permissions.editQuote) {
        this.editQuoteButton = true;
      }
      else {
        this.editQuoteButton = false;
      }

      if (permissions.finalizeQuote) {
        this.showFinalizeButton = true;
      }
      else {
        this.showFinalizeButton = false;
      }

      if (permissions.convertQuote) {
        this.showConvertButton = true;
      } else {
        this.showConvertButton = false;
      }
    })
  }

  async sendQuote(event: Event) {
    const popover = await this._popoverController.create({
      component: SendViaSocialMediaComponent,
      event: event,
      cssClass: "popup-component-social-media",
      componentProps: {
        onPathSelected: (data: any) => this.onSocialMediaActionOptionSelected(data), // Ensure the function is passed correctly
      }
    })
    return await popover.present()
  }

  onSocialMediaActionOptionSelected(data: any) {
    let selectedOption = data.path;

    switch (selectedOption) {
      case 'whatsApp': {
        this.sendQuoteViaWhatsApp();
        break;
      }
      case 'email': {
        this.sendQuoteViaEmail();
        break;
      }
    }
  }

  sendQuoteViaWhatsApp() {
    // TODO: implement send via whatsapp here
    window.open(`https://web.whatsapp.com`, '_blank');
  }

  async sendQuoteViaEmail() {
    const popover = await this._popoverController.create({
      component: LeadEmailInputComponent,
      cssClass: 'large-popover',
      componentProps: {
        leademail: this.leadDetails.email,
        onActionPerformed: (data: any) => {
          if (data) {
            this._emailService.sendQuote(this.quoteId, data, ORGANIZATION_TYPES.DMC).subscribe({
              next: () => {
                this._responseNotificationService.showMessage("Quote sent via email!");
                if (data.email !== this.leadDetails.email) {
                  this.leadDetails.email = data.email;
                  this.updateLeadData(this.leadDetails);
                }
              },
              error: (error) => {
                console.error('Error sending quote via email:', error);
                this._responseNotificationService.showMessage("Failed to send quote via email!", true);
              }
            })
          }
        }
      }
    })
    return await popover.present()
  }

  updateLeadData(formData: any) {
    this._leadService.updateLead(this.leadId, formData).subscribe();
  }

  enableSendQuoteButton() {
    if (this.quoteStatus) {
      return this.quoteStatus !== RECORD_STATUS_VALUES.DRAFT;
    } else {
      return false;
    }
  }
}
